import { Checkbox, Col, Collapse, Input, InputNumber, Radio, Row, Slider, Space } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
import {
    injOptions1,
    injOptions2,
    injOptions3,
    injOptions4,
    medicationFormatToTableMapping,
} from '../../../Templar/templateUtils';
const { Panel } = Collapse;

const injectionFormatToTableColumnSizeMapping = {
    'quantity-column': injOptions2,
    'quantity-column-without-border': injOptions3,
    'quantity-remarks-column-without-border': injOptions4,
};

const Injections: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    const injTableColumnSizes =
        injectionFormatToTableColumnSizeMapping[
            rxConfig?.injections_table_format as keyof typeof medicationFormatToTableMapping
        ] || injOptions1;

    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 w-26 h-26 flex items-center justify-center bg-darwin-accent-medicines-pink-800 ">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            fill="currentColor"
                            className="w-16 h-12 text-white"
                        >
                            <path d="M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4l-88.8 0L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-88.8c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel header={<div className="font-700">{sectionName || 'Injections'}</div>} key="1">
                <p className="mr-16 space-y-4">
                    <div>
                        <span className="font-700">Injections Table</span>

                        <Radio.Group
                            onChange={(e) => {
                                saveRxConfigInState({
                                    injections_table_format: e.target.value,
                                    injections_table_width: undefined,
                                });
                            }}
                            value={rxConfig?.injections_table_format ?? ''}
                            className="flex flex-col"
                        >
                            {' '}
                            <Radio value={''}>Default List Layout</Radio>
                            <Radio value={'table'}>Default Table{'    '}</Radio>
                            <Radio value={'quantity-column'}>Boxed Table with remarks in row</Radio>
                            <Radio value={'quantity-column-without-border'}>
                                Open Table with remarks in row
                            </Radio>{' '}
                            <Radio value={'quantity-remarks-column-without-border'}>
                                Open Table with remarks column
                            </Radio>
                        </Radio.Group>
                    </div>
                    {rxConfig?.injections_table_format ? (
                        <>
                            <Collapse
                                ghost
                                expandIcon={({ isActive }) => (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-10 h-10 fill-darwin-neutral-700"
                                        style={{
                                            rotate: isActive ? '180deg' : '90deg',
                                            transitionDuration: '0.2s',
                                        }}
                                    >
                                        <path d="M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480H472c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z" />
                                    </svg>
                                )}
                            >
                                <Panel
                                    header="Individual Column Width"
                                    key={1}
                                    className="pmh-collapse"
                                    extra={
                                        <div
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                saveRxConfigInState({
                                                    injections_table_width: undefined,
                                                });
                                            }}
                                            className="flex items-center space-x-4 cursor-pointer"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                                className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            >
                                                <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                            </svg>
                                        </div>
                                    }
                                >
                                    <div className="space-y-4">
                                        {Object.entries(
                                            injTableColumnSizes.injIdToNameMappingForWidth,
                                        ).map((data) => {
                                            console.log('data', data);
                                            const id = data[0];
                                            const name = data[1];

                                            return (
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center justify-between">
                                                        <div>{name}</div>{' '}
                                                    </div>

                                                    <Col span={12}>
                                                        <Slider
                                                            value={
                                                                rxConfig?.injections_table_width?.[
                                                                    id
                                                                ] ||
                                                                injTableColumnSizes
                                                                    ?.allColumnWidthInNumber?.[
                                                                    id as keyof typeof injTableColumnSizes.allColumnWidthInNumber
                                                                ]
                                                            }
                                                            min={0}
                                                            max={100}
                                                            step={1}
                                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                            // @ts-ignore
                                                            railStyle={{
                                                                background: '#cccfdb',
                                                            }}
                                                            onChange={(value) => {
                                                                saveRxConfigInState({
                                                                    injections_table_width: {
                                                                        ...(rxConfig?.injections_table_width ||
                                                                            {}),
                                                                        [id]: value || undefined,
                                                                    },
                                                                });
                                                            }}
                                                        />
                                                    </Col>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </Panel>
                            </Collapse>
                            <div>
                                <span className="font-700">Injections style</span>
                                <div className="cursor-pointer">
                                    <p
                                        className="cursor-pointer flex flex-1 items-center justify-between"
                                        onClick={() => {
                                            saveRxConfigInState({
                                                injections_name_in_capital: !rxConfig?.injections_name_in_capital,
                                            });
                                        }}
                                    >
                                        <span>Capitalize name</span>
                                        <Checkbox
                                            checked={rxConfig?.injections_name_in_capital}
                                        ></Checkbox>
                                    </p>
                                </div>
                                <div className="cursor-pointer">
                                    <p
                                        className="cursor-pointer flex flex-1 items-center justify-between"
                                        onClick={() => {
                                            saveRxConfigInState({
                                                make_generic_name_as_primary: !rxConfig?.make_generic_name_as_primary,
                                            });
                                        }}
                                    >
                                        <span>Generic as Primary Name</span>
                                        <Checkbox
                                            checked={rxConfig?.make_generic_name_as_primary}
                                        ></Checkbox>
                                    </p>
                                </div>

                                <div className="cursor-pointer">
                                    <p
                                        className="cursor-pointer flex flex-1 items-center justify-between"
                                        onClick={() => {
                                            saveRxConfigInState({
                                                injections_heading_hide: !rxConfig?.injections_heading_hide,
                                            });
                                        }}
                                    >
                                        <span>Hide Table Heading</span>
                                        <Checkbox
                                            checked={rxConfig?.injections_heading_hide}
                                        ></Checkbox>
                                    </p>
                                </div>

                                {rxConfig?.injections_heading_hide ? null : (
                                    <div className="cursor-pointer pt-8">
                                        <p className="cursor-pointer flex flex-1 items-center justify-between">
                                            <span className="whitespace-nowrap">Heading Name</span>
                                            <Input
                                                style={{
                                                    margin: '0 0 0 16px',
                                                }}
                                                size="small"
                                                defaultValue={
                                                    rxConfig?.injections_table_heading_text ||
                                                    'INJECTIONS'
                                                }
                                                value={rxConfig?.injections_table_heading_text}
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        injections_table_heading_text:
                                                            e.target.value,
                                                    });
                                                }}
                                            />
                                        </p>
                                    </div>
                                )}
                            </div>

                            {rxConfig?.injections_heading_hide ? null : (
                                <div>
                                    <div className="space-y-4">
                                        <span className="font-700">Heading alignment</span>

                                        <div className="flex justify-center">
                                            <Radio.Group
                                                value={rxConfig?.injections_table_title_alignment}
                                                size="middle"
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        injections_table_title_alignment:
                                                            e.target.value,
                                                    });
                                                }}
                                            >
                                                <Radio.Button
                                                    style={{
                                                        paddingLeft: '16px',
                                                        paddingRight: '16px',
                                                    }}
                                                    value="left"
                                                >
                                                    Left
                                                </Radio.Button>
                                                <Radio.Button
                                                    style={{
                                                        paddingLeft: '16px',
                                                        paddingRight: '16px',
                                                    }}
                                                    value="center"
                                                >
                                                    Center
                                                </Radio.Button>
                                                <Radio.Button
                                                    style={{
                                                        paddingLeft: '16px',
                                                        paddingRight: '16px',
                                                    }}
                                                    value="right"
                                                >
                                                    Right
                                                </Radio.Button>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="border-b border-darwin-neutral-200 mx-8"></div>
                            <div className="flex items-center justify-between">
                                <div>Table title background color:</div>{' '}
                                <div className="flex space-x-12">
                                    <input
                                        type="color"
                                        id="head"
                                        name="head"
                                        value={
                                            rxConfig?.injections_table_title_bg_color || '#E4DEEB'
                                        }
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                injections_table_title_bg_color: e.target.value,
                                            });
                                        }}
                                        className="circular-color-input"
                                    />

                                    <AntTooltip content="Reset">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            onClick={() => {
                                                saveRxConfigInState({
                                                    injections_table_title_bg_color: '',
                                                });
                                            }}
                                        >
                                            <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                        </svg>
                                    </AntTooltip>
                                </div>
                            </div>
                            <div className="flex items-center justify-between">
                                <div>Table border color:</div>{' '}
                                <div className="flex space-x-12">
                                    <input
                                        type="color"
                                        id="head"
                                        name="head"
                                        value={rxConfig?.injections_table_border_color || '#8064A2'}
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                injections_table_border_color: e.target.value,
                                            });
                                        }}
                                        className="circular-color-input"
                                    />

                                    <AntTooltip content="Reset">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            onClick={() => {
                                                saveRxConfigInState({
                                                    injections_table_border_color: '',
                                                });
                                            }}
                                        >
                                            <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                        </svg>
                                    </AntTooltip>
                                </div>
                            </div>
                            <div className="flex items-center justify-between">
                                <div>Table Heading color:</div>{' '}
                                <div className="flex space-x-12">
                                    <input
                                        type="color"
                                        id="head"
                                        name="head"
                                        value={rxConfig?.injections_table_header_color || '#8064A2'}
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                injections_table_header_color: e.target.value,
                                            });
                                        }}
                                        className="circular-color-input"
                                    />

                                    <AntTooltip content="Reset">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            onClick={() => {
                                                saveRxConfigInState({
                                                    injections_table_header_color: '',
                                                });
                                            }}
                                        >
                                            <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                        </svg>
                                    </AntTooltip>
                                </div>
                            </div>
                        </>
                    ) : null}
                </p>
            </Panel>
        </Collapse>
    );
};

export default Injections;
